import { addProfilePageBobWidget } from '../../editor/services';
import { toMonitored } from '../../editor/services/monitor';
import type { PlatformContext } from '../../types';

export const installMemberPage = ({
  editorSDK,
  options,
  appDefinitionId,
  flowAPI,
}: PlatformContext) => {
  return toMonitored('install.add-profile-page-bob-widget', () =>
    addProfilePageBobWidget({
      editorSDK,
      options,
      appDefinitionId,
      flowAPI,
    }),
  );
};
